module.exports = __webpack_public_path__ + "static/media/em-18.ef2a2185.png";